import React from 'react';
import { Switch } from '../../../../common';
import './style.scss';

export const ThemeSwitcher = ({ switchTheme, isDarkTheme }) => (
  <span className="theme_switcher">
    <span className="theme_switcher_left">Light</span>
    <Switch
      onChange={switchTheme}
      label="Dark"
      checked={isDarkTheme}
    />
  </span>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/ThemeSwitcher/index.js